import React, { createContext, useContext, useState, useEffect } from 'react';
import {getCookieValue} from "../../utils/cookieUtils";

const FilterContext = createContext(undefined);

export const FilterProvider = ({ children }) => {
    const [filterCategoryId, setFilterCategoryId] = useState(null);
    const [cartCount, setCartCount] = useState(0);
    const [homeAccToken, setHomeAccToken] = useState('');

    useEffect(() => {
        const homeAccTokenValue = getCookieValue('home_ACC_TOKEN');
        setHomeAccToken(homeAccTokenValue);
    }, []);

    const handleCategoryChange = (categoryId) => {
        setFilterCategoryId(categoryId);
    };

    return (
        <FilterContext.Provider value={{ filterCategoryId, handleCategoryChange, cartCount, setCartCount, homeAccToken }}>
            {children}
        </FilterContext.Provider>
    );
};

export const useFilter = () => useContext(FilterContext);
